<template>
  <div class="edit-table">
    <div class="box">
      <div>
        关联的物料使用申请<i
          v-if="!disabled"
          class="el-icon-plus icon-style-jia"
          @click="addTable"
        ></i>
      </div>
      <div class="text">{{ (subjectList[0] || {}).code || "" }}</div>
    </div>
    <!-- 弹框 -->
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '../../../../../../components/select_org_cus_ter/select_config.vue';

export default {
  name: 'BudgetSubject',
  components: {
    SelectConfig,
  },
  props: {
    saveRef: Function,
    value: Object,
    disabled: Boolean,
    isMaterial: String,
  },
  watch: {
    value: {
      handler(val) {
        this.subjectList = val.data || [];
      },
      deep: true,
      immediate: true,
    },
    isMaterial: {
      deep: true,
      immediate: true,
    },
  },
  data() {
    return {
      subjectList: [], // 当前关联费用科目数据
    };
  },
  created() {},
  mounted() {
    if (this.saveRef) {
      this.saveRef(this);
    }
  },
  methods: {
    // 新增预算信息
    addTable() {
      const params = {
        functionCode: 'material_list',
        data: this.subjectList,
        idKey: 'code',
        noReset: true,
        paramData: {
          enableStatus: '009',
          approveStatus: '2',
          actFlag: 'true',
          filterCloseFlag: '1',
        },
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
    // 判断去重
    getReset(list1, list2, key) {
      const list = list2;
      if (list1 && list1.length) {
        list1.forEach((v1) => {
          let notRepeat = true;
          const rowData = v1;
          for (const v2 in list2) {
            if (v1[key] === list2[v2][key]) {
              notRepeat = true;
              return false;
            }
          }
          if (notRepeat) {
            list.push(rowData);
          }
          return rowData;
        });
      }
      return list;
    },
    onGetSelect(val) {
      if (this.isMaterial === 'Y' && val[0].closeInProcessFlag === '1') {
        return this.$message.error('当前物料立项申请存在审批中的关闭申请，无法使用');
      }
      const data = this.getReset(val, [], 'code');
      this.value.data = data;
      this.subjectList = data;
      this.$emit('change', data);
    },
  },
};
</script>

<style lang="less" scoped>
.edit-table {
  padding-left: 50px;
}
.box {
  display: flex;
}
.text {
  margin-left: 10px;
}
.icon-style-jia {
  color: #c34231;
  font-weight: bold;
  margin-left: 10px;
}
</style>
